import React, { useEffect, useRef } from 'react';

const ScrollToBottom = ({ children }) => {
  const endOfMessagesRef = useRef(null);

  const scrollToBottom = () => {
    endOfMessagesRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [children]);

  return (
    <div className="scroll-to-bottom-container" style={{ flex: 1, overflowY: 'auto' }}>
      {children}
      <div ref={endOfMessagesRef} />
    </div>
  );
};

export default ScrollToBottom;




// import React, { useEffect, useRef } from 'react';

// const ScrollToBottom = ({ children }) => {
//   const endOfMessagesRef = useRef(null);

//   const scrollToBottom = () => {
//     endOfMessagesRef.current?.scrollIntoView({ behavior: 'smooth' });
//   };

//   useEffect(() => {
//     scrollToBottom();
//   }, [children]);

//   return (
//     <div className="scroll-to-bottom-container">
//       {children}
//       <div ref={endOfMessagesRef} />
//     </div>
//   );
// };

// export default ScrollToBottom;
